const LINKED_STATE_FIELD =
  /"field"\s*:\s*"(user_status|user_health|organisation_status|organisation_paid_by|accounting_connection|health_check|trial_offer|first_payment|feature_activation|login_activity)"/u;

/**
 * True when a serialized Contacts filter list carries an M39 linked-state
 * clause (user status/health, or organisation status, payer, accounting
 * connection or health check). Such a clause is
 * refused (403) without its linked-state read access; the page explains it.
 *
 * The suppression keys on the request, not the error code: another 403 on a
 * read that carries such a clause (tags access, revoked CRM view) also skips
 * the app-wide dialog and falls to the page's generic notice.
 */
export const hasCrmLinkedStateFilter = (filters: unknown): boolean => {
  if (typeof filters !== "string" || filters.length === 0) return false;
  if (LINKED_STATE_FIELD.test(filters)) return true;
  try {
    return LINKED_STATE_FIELD.test(decodeURIComponent(filters));
  } catch {
    return false;
  }
};

const LINKED_STATE_FIELDS = new Set([
  "user_status",
  "user_health",
  "organisation_status",
  "organisation_paid_by",
  // Organisation state with the same read access (Contacts filters).
  "accounting_connection",
  "health_check",
  "trial_offer",
  "first_payment",
  "feature_activation",
  "login_activity",
]);

/**
 * The suggestions body's form: the draft clauses plus the active row. Either
 * carrying a linked-state field is refused the same way as the list read.
 */
export const hasCrmLinkedStateClause = (body: {
  filters?: ReadonlyArray<{ field: string }>;
  activeClause?: { field: string };
}): boolean => {
  if (body.activeClause && LINKED_STATE_FIELDS.has(body.activeClause.field))
    return true;
  return (body.filters ?? []).some((clause) =>
    LINKED_STATE_FIELDS.has(clause.field),
  );
};
